import { useCallback, useEffect } from 'react';

import { DatasetRuleButton } from '@/Pages/Dataset/DatasetRulesPane';
import { DatasetRulesDropdown } from '@/components/EvaluatorPopover/EvaluatorsPopover';
import { useRunRules } from '@/hooks/useSwr';

import { usePlaygroundStore } from '../PlaygroundHome/hooks/usePlaygroundStore';

export function PlaygroundDatasetRules({
  datasetId,
  minimized,
}: {
  datasetId: string;
  minimized?: boolean;
}) {
  const { data: rulesUnfiltered } = useRunRules({ dataset_id: datasetId });
  const rules = rulesUnfiltered?.filter((r) => r.is_enabled);

  const { excludedEvaluatorIds, setExcludedEvaluatorIds } =
    usePlaygroundStore();

  useEffect(() => {
    setExcludedEvaluatorIds(new Set<string>());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isRuleSelected = useCallback(
    (ruleId: string) => !excludedEvaluatorIds.has(ruleId),
    [excludedEvaluatorIds]
  );

  const handleSelectRuleId = (ruleId: string, isSelectedOrDeleted: boolean) => {
    if (isSelectedOrDeleted) {
      const newSet = new Set(excludedEvaluatorIds);
      newSet.delete(ruleId);
      setExcludedEvaluatorIds(newSet);
    } else {
      const newSet = new Set(excludedEvaluatorIds);
      newSet.add(ruleId);
      setExcludedEvaluatorIds(newSet);
    }
  };

  return (
    <DatasetRulesDropdown
      trigger={
        <DatasetRuleButton
          datasetId={datasetId}
          onClick={() => void 0}
          variant="playground"
          minimized={minimized}
          customNumRules={
            rules?.length ? rules.length - excludedEvaluatorIds.size : 0
          }
        />
      }
      datasetId={datasetId}
      isRuleSelected={isRuleSelected}
      handleSelectRule={handleSelectRuleId}
      checkable={true}
      popoverProps={{
        side: 'left',
        sideOffset: 4,
        align: 'center',
      }}
    />
  );
}
